import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NodeParams } from '@base/NodeParams';
import { environment } from '@env/environment';
import { Node } from '@models/node/Node';
import { QuestionBank } from '@models/question-bank/QuestionBank';
import { Response } from '@models/response-api/ResponseApi';

@Injectable({
	providedIn: 'root',
})
export class QuestionBankService extends NodeParams {
	private url = `${environment.hostAPI}/questionbanks`;

	constructor(private http: HttpClient) {
		super();
	}

	getByPagination(node: Node) {
		const url = `${this.url}/all`;
		const params = this.getParams(node);
		return this.http.get<Response>(url, { params });
	}

	getById(id: number) {
		const url = `${this.url}?id=${id}&image=${true}&idplan=${null}`;
		return this.http.get<Response>(url);
	}


  getReadingPlanById(id: number) {
    const url = `${this.url}?id=${null}&image=${true}&idplan=${id}`;
    return this.http.get<Response>(url);
  }

  getStructure(nodeId: number) {
    const url = `${environment.hostAPI}/nodes/${nodeId}/structure?generateExam=0`;
    return this.http.get<Response>(url);
  }

	save(questionBank: QuestionBank) {
		return this.http.post<Response>(this.url, questionBank);
	}

	update(questionBank: QuestionBank) {
		return this.http.put<Response>(this.url, questionBank);
	}

	// LOAD QUESTION FROM RESPONSE FILE CSV
	load(questionBank: QuestionBank) {
		const url = `${this.url}/load`;
		return this.http.post<Response>(url, questionBank);
	}

  upload(file: File) {
    const url = `${this.url}/parse-file`;
    const formData = new FormData();
    formData.append("file", file);
    return this.http.post<Response>(url, formData, {reportProgress: true, observe: "events"});
  }

  remove(questionBank: QuestionBank) {
    const url = `${this.url}/${questionBank.id}/status`
    return this.http.put<Response>(url, {id: questionBank.id, status: questionBank.active});
  }

	// Obtener todos los bancos de preguntas que estan asignados a un nodo en específico
	geAlltByNodeId(nodeId: number) {
		const url = `${this.url}/node?nodeId=${nodeId}`;
		return this.http.get<Response>(url);
	}

	// Obtiene los datos de un banco de preguntas por identificador
	getBydId(id: number, idplan: null) {
		const status = true;
		const url = `${this.url}?id=${id}&image=${status}&idplan=${idplan}`;
		return this.http.get<Response>(url);
		// return this.httpService.get(apiUrl).map((response: { json: () => any; }) => response.json());
	}

	// Obtiene la estructura de los elementos que tiene examenes
	getList(ids: string) {
		let url = `${this.url}/list?ids=${ids}`;
		return this.http.get<Response>(url);
	}
}
